export const MODAL_REQUEST = 'MODAL_REQUEST';
